module.exports = __webpack_public_path__ + "img/insta.75bfee0a.svg";